'use client';

import { Box, Button, Text } from '@doist/marketist';
import { useTranslation } from 'next-i18next';
import { useCTAsData } from 'services/hooks/use-ctas-data';
import { PricingInfo } from '../../pricing-info/pricing-info';
import css from './pricing-table.module.css';
import type { Teams } from 'types/pricing';
function Plan({
  planName
}: {
  planName: Teams.PricingPlan;
}) {
  const {
    t
  } = useTranslation('pricing_v2_3');
  const proCtaData = useCTAsData('pricing-page-showcase-pro');
  const businessCtaData = useCTAsData('pricing-page-showcase-business');
  return <Box className={css.plan} data-sentry-element="Box" data-sentry-component="Plan" data-sentry-source-file="plan-names.tsx">
            <Text size="major-sm" className="mbe-32" data-sentry-element="Text" data-sentry-source-file="plan-names.tsx">
                {t(`plans.names.${planName}`)}
            </Text>
            <PricingInfo plan={planName} data-sentry-element="PricingInfo" data-sentry-source-file="plan-names.tsx" />
            {planName === 'pro' && proCtaData ? <Box className={css.buttonContainer}>
                    <Button variant={proCtaData.variant} size="small" href={proCtaData.href} {...proCtaData.dataAttributes}>
                        {proCtaData.text}
                    </Button>
                </Box> : null}
            {planName === 'teams' && businessCtaData ? <Box className={css.buttonContainer}>
                    <Button variant={businessCtaData.variant} size="small" href={businessCtaData.href} {...businessCtaData.dataAttributes}>
                        {businessCtaData.text}
                    </Button>
                </Box> : null}
        </Box>;
}
function PlanNames() {
  return <Box className={css.planNamesSticky} data-sentry-element="Box" data-sentry-component="PlanNames" data-sentry-source-file="plan-names.tsx">
            <Plan planName="beginner" data-sentry-element="Plan" data-sentry-source-file="plan-names.tsx" />
            <Plan planName="pro" data-sentry-element="Plan" data-sentry-source-file="plan-names.tsx" />
            <Plan planName="teams" data-sentry-element="Plan" data-sentry-source-file="plan-names.tsx" />
        </Box>;
}
export { PlanNames };